export default __webpack_public_path__ + "static/media/water-3.a0dedadc.png";